import React from 'react';





const NotificationsTab = (props) => {

    
   
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
       
       NotificationsTab

        </div>
    );
};

export default NotificationsTab;